import { render } from "./BlFormFieldModeloptionselector.vue?vue&type=template&id=6b351825&scoped=true"
import script from "./BlFormFieldModeloptionselector.vue?vue&type=script&lang=js"
export * from "./BlFormFieldModeloptionselector.vue?vue&type=script&lang=js"

import "./BlFormFieldModeloptionselector.vue?vue&type=style&index=0&id=6b351825&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b351825"]])

export default __exports__